module.exports = __webpack_public_path__ + "static/img/logo108.eaa7abf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo108.png
// module id = qIQG
// module chunks = 1